import React from 'react';
const StatusEquipped = () => {
  return (
    <svg width="60px" height="16px" viewBox="0 0 60 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Component/Toggle/Status-Alternativ/2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Background">
          <rect fill="#CCCFDA" x="0" y="0" width="60" height="16" rx="8"></rect>
          <rect fill="#5AAAFA" x="0" y="0" width="31" height="16" rx="8"></rect>
        </g>
      </g>
    </svg>
  );
};
export default StatusEquipped;
